<div class="">
    <mat-form-field appearance="standard" class="select-dropdown">
        <mat-icon matSuffix><span class="material-symbols-outlined"> expand_more </span></mat-icon>
        <mat-select [(value)]="selectedValue" (selectionChange)="onSelectionChange($event)">
            <mat-option *ngFor="let option of selectList" [value]="option.value">
                {{ option.viewValue | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
